import { useEffect } from "react";
import LeftSideBar, { FolderCollapse } from "../../components/SideBar/LeftSideBar";
import Navbar from "../../Layouts/Navbar/Navbar";
import ResizableComponent from "../../Layouts/ResizableComponent";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import ConnectorForm from "./ConnectorForm";
import DBConfiguration from "./DBConfiguration/DBConfiguration";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { useDBConnectorsContext } from "../../context/DBConnectorContext";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

export default function DBConnectors() {
  const {
    explorerData,
    selectedConnector,
    schema,
    showPopup,
    setExplorerData,
    fetchConnectors,
    handleSave,
    getSchema,
    handleDelete,
    handleConnectorSelect,
    togglePopup
  } = useDBConnectorsContext();

  useEffect(() => {
    fetchConnectors();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <section className="main_section">
        <div className="sub_section">
          <div>
            <ResizableComponent
              resizeSide="right"
              storageKey="left_sidebar_size"
              defaultSize={244}
              range={[244, 400]} // Specify the range as [minSize, maxSize]
              collapsible={true}
            >
              <HeaderModes />
              <div className="d_flex">
                <Navbar />
                <LeftSideBar
                  explorerData={explorerData}
                  setExplorerData={setExplorerData}
                  selectedScreen={selectedConnector}
                  handleNewInsert={() => togglePopup(true)}
                  handleDelete={handleDelete}
                  callbackFunction={handleConnectorSelect}
                  type="DataBases"
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <FolderCollapse explorerData={explorerData} setExplorerData={setExplorerData} type="template" />
                  </div>
                </LeftSideBar>
              </div>
            </ResizableComponent>
          </div>

          {!showPopup && selectedConnector && (
            <div className="content_main_section">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="d_flex">
                  <PageInfoAndActionBar
                    pagePath={`Connectors/${selectedConnector?.name}`}
                    currentConfig={[schema]}
                    pageName="DB Connector"
                  />
                  <div
                    style={{
                      background: "var(--builder-bg)",
                      borderBottom: "1px solid var(--builder-border)",
                      height: "48px"
                    }}
                    className="d_flex align_center justify_center"
                  >
                    <MaterialIcon
                      name="refresh"
                      className="screen_top_icons mr_3"
                      onClick={() => getSchema(selectedConnector.id, true)}
                      title="Refresh"
                    />
                    <MaterialIcon name="save" className="screen_top_icons mr_3" onClick={handleSave} />
                  </div>
                </div>
                <div className="builder_form">
                  <DBConfiguration />
                </div>
              </div>
            </div>
          )}

          <BuilderModal isOpen={showPopup} modalName="Add Connector" onClose={() => togglePopup(false)}>
            <ConnectorForm handleClose={() => togglePopup(false)} />
          </BuilderModal>
        </div>
      </section>
    </div>
  );
}
